export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";

export const toggleLanguageAction = () => {
  return { type: TOGGLE_LANGUAGE };
};
